export const Colors = {
  availableColor: '#22cc44',
  partiallyAvailableColor: '#e68739',
  vacationColor: '#0492C2',
  vacationConflictBookingColor: '#dd6666',
  vacationAndBookingColor: `linear-gradient(90deg, #0492C2 50%, #dd6666 50%)`,
  leihbarBookingOverdueColor: '#fff94e',
  leihbarBookingConflictingColor: '#f16c6c',
  leihbarBookingOverdueColorLight: '#fff94e77',
  leihbarBookingConflictingColorLight: '#f16c6c77'
};
